export default "__VITE_ASSET__Op0mogXE__"